module.exports = __webpack_public_path__ + "img/eye-pink.e28ee74f.svg";